import api from '../lib/api';
import type { ApiResponse } from '@maios/shared';

export interface StorageOverview {
  totalUsed: number;
  totalLimit: number;
  usageRate: number;
  organizationCount: number;
  warningCount: number;
  criticalCount: number;
  disk: { total: number; used: number; free: number; usageRate: number } | null;
}

export interface StorageRankingItem {
  id: string;
  name: string;
  slug: string;
  planType: string;
  storageUsedBytes: number;
  storageLimitBytes: number;
  usageRate: number;
  status: 'normal' | 'warning' | 'critical';
}

export async function getStorageOverview(): Promise<StorageOverview> {
  const res = await api.get<ApiResponse<StorageOverview>>('/admin/storage/overview');
  return res.data.data!;
}

export async function getStorageRanking(limit?: number): Promise<{ items: StorageRankingItem[] }> {
  const query = limit ? `?limit=${limit}` : '';
  const res = await api.get<ApiResponse<{ items: StorageRankingItem[] }>>(`/admin/storage/ranking${query}`);
  return res.data.data!;
}
